import { graphql } from 'gatsby';

import BlockListLargeSection from 'design-system/src/components/organisms/BlockListLargeSection';

export default BlockListLargeSection;

export const query = graphql`
    fragment DatoCmsBlockListLargeSection on DatoCmsBlockListLargeSection {
        title
        titleTag
        items {
            ...Button
        }
    }
`;
